module.exports = __webpack_public_path__ + "img/CarrotRight.0dfac11a.svg";